export const vehicleCategoryOptions = [
    {
        label: "Επιβατικό Ι.Χ.",
        value: "ΕΠΙΒΑΤΙΚΟ"
    },
    {
        label: "Φορτηγό Ι.Χ. (αγροτικό, βαν κ.λπ.)",
        value: "ΦΟΡΤΗΓΟ"
    },
    {
        label: "Δίκυκλο Ι.Χ. (μοτοσυκλέτα, μοτοποδήλατο)",
        value: "ΔΙΚΥΚΛΟ"
    },
    {
        label: "Λεωφορείο Ι.Χ. (π.χ. τουριστικό λεωφορείο ιδιωτικής επιχείρησης)",
        value: "ΛΕΩΦΟΡΕΙΟ"
    },
    {
        label: "Τετράκυκλο/ATV Ι.Χ.",
        value: "ΤΕΤΡΑΚΥΚΛΟ"
    },
    {
        label: "Επιβατικό Δ.Χ. (ΤΑΞΙ)",
        value: "ΕΠΙΒΑΤΙΚΟ ΔΗΜΟΣΙΑΣ ΧΡΗΣΗΣ (ΕΔΧ - ΤΑΞΙ) Ε.Δ.Χ. - ΤΑΞΙ"
    },
    {
        label: "Επιβατικό Δ.Χ. (ΤΑΞΙ)",
        value: "ΕΠΙΒΑΤΙΚΟ ΔΗΜΟΣΙΑΣ ΧΡΗΣΗΣ (ΕΔΧ - ΤΑΞΙ) ΚΟΙΝΟ"
    },
    {
        label: "Λεωφορείο Δ.Χ. (π.χ. ΚΤΕΛ, τουριστικά, σχολικά)",
        value: "ΛΕΩΦΟΡΕΙΟ Δ.Χ."
    },
    {
        label: "Φορτηγό Δ.Χ. (φορτηγά που εκτελούν δημόσιες μεταφορές)",
        value: "ΦΟΡΤΗΓΟ Δ.Χ."
    },
    {
        label: "Αγροτικό Δ.Χ. (σπάνιο, για συνεταιρισμούς κ.λπ.)",
        value: "ΑΓΡΟΤΙΚΟ Δ.Χ."
    },
    {
        label: "ΦΟΡΤΗΓΟ ΒΥΤΙΟΦΟΡΟ ΥΓΡΩΝ ΚΑΥΣΙΜΩΝ",
        value: "ΦΟΡΤΗΓΟ ΒΥΤΙΟΦΟΡΟ ΥΓΡΩΝ ΚΑΥΣΙΜΩΝ"
    },
    {
        label: "ΦΟΡΤΗΓΟ ΚΟΙΝΟ ΜΗ ΑΝΑΤΡΕΠΟΜΕΝΟ",
        value: "ΦΟΡΤΗΓΟ ΚΟΙΝΟ ΜΗ ΑΝΑΤΡΕΠΟΜΕΝΟ"
    }
]
